import React from 'react'
import { connect } from 'react-redux'
import { LoginButton as El } from '../../AuthGoogle'
import * as Sentry from '@sentry/browser';

const mapStateToProps = (state, params) => {
  return {
    text: state.localization.dictionary.login.loginGoogle,
  }
}

const onSuccess = (response) => {
  window.location.reload()
}

const onError = (error, user) => {
  // TODO: How should we handle these scenarios in this flow?

  // Captcha or CSRF error
  if (error.id === 5107) {
    // Show login with appropriate error message
    window.location.assign('/login?e=24')
  }
  else if (error.id === 5104) {
    // Google authed but not recognized account. Create it?
    window.location.assign(`/signup_interim?email=${user.email}`)
  }
  else {
    Sentry.captureMessage('Login Google button unknown error')
  }
}

const GoogleButton = (props) => {
  return (
    <El
      children={ props.text }
      onError={ onError }
      onSuccess={ onSuccess } />
  )
}

const ConnectedGoogleButton = connect(
  mapStateToProps
)(GoogleButton)

export {
  ConnectedGoogleButton as GoogleButton
}
